import { Component, Input } from '@angular/core';
import { IBreadcrumbLink } from '@suvo/frontend-framework/SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/breadcrumbs/interfaces/breadcrumb-link.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-dashboard-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class DashboardBreadcrumbsComponent {
  @Input() links: IBreadcrumbLink[] = [];
}
